(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');

  const reveal = () => {
    const items = document.querySelectorAll(
      '.template-index main > .shopify-section:not(:first-child), .namtek-reveal'
    );
    if (reducedMotion.matches || !('IntersectionObserver' in window)) {
      items.forEach((item) => item.classList.add('is-visible'));
      return;
    }
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    items.forEach((item) => {
      item.classList.add('namtek-reveal');
      observer.observe(item);
    });
  };

  const tiltCards = () => {
    if (!finePointer.matches || reducedMotion.matches) return;
    document.querySelectorAll('.card-wrapper').forEach((wrapper) => {
      const card = wrapper.querySelector('.card');
      if (!card || wrapper.dataset.namtekTilt === 'ready') return;
      wrapper.dataset.namtekTilt = 'ready';
      wrapper.addEventListener('pointermove', (event) => {
        const rect = wrapper.getBoundingClientRect();
        const x = (event.clientX - rect.left) / rect.width;
        const y = (event.clientY - rect.top) / rect.height;
        card.style.setProperty('--tilt-x', `${(0.5 - y) * 7}deg`);
        card.style.setProperty('--tilt-y', `${(x - 0.5) * 9}deg`);
        card.style.setProperty('--shine-x', `${x * 100}%`);
        card.style.setProperty('--shine-y', `${y * 100}%`);
      });
      wrapper.addEventListener('pointerleave', () => {
        card.style.setProperty('--tilt-x', '0deg');
        card.style.setProperty('--tilt-y', '0deg');
      });
    });
  };

  const parallax = () => {
    if (reducedMotion.matches) return;
    if (document.documentElement.dataset.namtekParallax === 'ready') return;
    document.documentElement.dataset.namtekParallax = 'ready';
    let queued = false;
    const update = () => {
      const viewport = window.innerHeight;
      const layers = [...document.querySelectorAll('[data-namtek-depth]')];
      layers.forEach((layer) => {
        const host = layer.closest('[data-namtek-scene]') || layer;
        const rect = host.getBoundingClientRect();
        if (rect.bottom < 0 || rect.top > viewport) return;
        const progress = (viewport - rect.top) / (viewport + rect.height);
        const depth = Number(layer.dataset.namtekDepth || 1);
        layer.style.setProperty('--namtek-shift', `${(progress - 0.5) * depth * 32}px`);
      });
      queued = false;
    };
    const queue = () => {
      if (!queued) {
        queued = true;
        requestAnimationFrame(update);
      }
    };
    update();
    addEventListener('scroll', queue, { passive: true });
    addEventListener('resize', queue, { passive: true });
  };

  const init = () => {
    reveal();
    tiltCards();
    parallax();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
